import {
  CreditNoteRevenueRecognitionMethod,
  CreditNoteServicePeriod
} from 'CreditNotes/types'

/**
 * Minimal line item shape the rev-rec warning UI needs. Both the credit note
 * detail `LineItem` and the issue-credit-note drawer's row satisfy it, so the
 * banner and message builder are reusable across both flows.
 */
export type IncompleteRevRecLineItem = {
  id: string
  title: string
  servicePeriod?: CreditNoteServicePeriod
  revenueRecognitionMethod?: CreditNoteRevenueRecognitionMethod
}

export const buildMissingFieldsMessage = (
  items: IncompleteRevRecLineItem[]
): string => {
  const missingServicePeriod = items.some(item => !item.servicePeriod)
  const missingRecognitionMethod = items.some(
    item => !item.revenueRecognitionMethod
  )
  const suffix =
    items.length > 1
      ? ' to every line item before issuing.'
      : ' before issuing.'

  if (missingServicePeriod && missingRecognitionMethod) {
    return `Add a service period and recognition method${suffix}`
  }
  if (missingServicePeriod) {
    return `Add a service period${suffix}`
  }
  return `Add a recognition method${suffix}`
}
